import React from "react"
import { Country } from "@/modules/patients/services/__generated__/PatientFragment.graphql"

type IconMap = {
  [key in Country]: (props: IconProps) => React.JSX.Element
}

interface CountryIconProps extends React.SVGProps<SVGElement> {
  country: Country
  size?: number
}

interface IconProps extends React.SVGProps<SVGElement> {
  size?: number
}

const iconMap: IconMap = {
  CH: ({ size = 24 }: IconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      style={{ borderRadius: "2px" }}>
      <path fill="#D52B1E" fillRule="evenodd" d="M0 0h24v24H0V0Z" clipRule="evenodd" />
      <path fill="#fff" fillRule="evenodd" d="M4.5 9.75h15v4.5h-15v-4.5Z" clipRule="evenodd" />
      <path fill="#fff" fillRule="evenodd" d="M9.75 4.5h4.5v15h-4.5v-15Z" clipRule="evenodd" />
    </svg>
  ),
  DE: ({ size = 24 }: IconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="currentColor"
      style={{ borderRadius: "2px" }}>
      <path fill="#FFCE00" d="M0 15.998h24V24H0v-8.002Z" />
      <path fill="#000" d="M0 0h24v8.002H0V0Z" />
      <path fill="#D00" d="M0 8.001h24v7.997H0V8.001Z" />
    </svg>
  ),
  // FR: ({ size = 24 }: IconProps) => (
  //   <svg
  //     xmlns="http://www.w3.org/2000/svg"
  //     width={size}
  //     height={size}
  //     fill="currentColor"
  //     style={{ borderRadius: "2px" }}>
  //     <path fill="#fff" fillRule="evenodd" d="M0 0h24v24H0V0Z" clipRule="evenodd" />
  //     <path fill="#002654" fillRule="evenodd" d="M0 0h8.002v24H0V0Z" clipRule="evenodd" />
  //     <path fill="#CE1126" fillRule="evenodd" d="M15.998 0H24v24h-8.002V0Z" clipRule="evenodd" />
  //   </svg>
  // ),
  // IT: ({ size = 24 }: IconProps) => (
  //   <svg
  //     xmlns="http://www.w3.org/2000/svg"
  //     width={size}
  //     height={size}
  //     fill="currentColor"
  //     style={{ borderRadius: "2px" }}>
  //     <path fill="#fff" fillRule="evenodd" d="M0 0h24v24H0V0Z" clipRule="evenodd" />
  //     <path fill="#009246" fillRule="evenodd" d="M0 0h8.002v24H0V0Z" clipRule="evenodd" />
  //     <path fill="#CE2B37" fillRule="evenodd" d="M15.998 0H24v24h-8.002V0Z" clipRule="evenodd" />
  //   </svg>
  // ),
}

const CountryIcon = ({ country, ...otherProps }: CountryIconProps) => {
  const IconComp = iconMap[country]

  return <IconComp {...otherProps} />
}

export { CountryIcon }
